import { Column } from "components/Table/Simple";
import { formatDateTime, truncate } from "components/Table/Simple/presets";

export const columns: Column[] = [
    {
        label: "ID",
        field: "id",
    },
    {
        label: "의원명",
        field: "clinic",
        render: (value, field, row) => row?.clinic?.name,
    },
    {
        label: "제목",
        field: "title",
        creatable: true,
    },
    {
        label: "내용",
        field: "content",
        creatable: true,
        render: (value, field, row) => truncate(value, 30),
    },
    {
        label: "시술전사진",
        field: "beforePhotos",
        visible: false,
    },
    {
        label: "시술후사진",
        field: "afterPhotos",
        visible: false,
    },
    {
        label: "이벤트",
        field: "event",
        render: (value, field, row) => row?.event?.title,
    },
    {
        label: "진료과목",
        field: "treatments",
        render: (value, field, row) => row?.treatments?.map((t) => t.name).join(", "),
    },
    {
        label: "시술의사",
        field: "doctors",
        render: (value, field, row) => row?.doctors?.map((d) => d.name).join(", "),
    },
    {
        field: "created_at",
        label: "생성일",
        render: formatDateTime
    },
    {
        field: "updated_at",
        label: "수정일",
        render: formatDateTime
    },
    {
        field: "writer_id",
        label: "작성자 ID",
    },
    {
        field: "clinic_id",
        label: "의원 ID",
    },
    {
        field: "event_id",
        label: "이벤트 ID",
    },
    {
        field: "counsel_id",
        label: "상담 ID",
    },
    {
        field: "rating",
        label: "평점",
    },
    {
        field: "writer",
        label: "작성자",
        render: (value, field, row) => row?.writer?.name,
    }
];